<template>
    <div style="background: white">
        <a-tabs :defaultActiveKey="defaultTab" @change="changeTab">
            <a-tab-pane :tab="$t('label.users')" key="users" />
            <a-tab-pane :tab="$t('label.groups')" key="groups" />
        </a-tabs>
    </div>
</template>
<script>
export default {
    props: {
        defaultTab: {
            type: String,
            default: 'users',
        },
    },
    methods: {
        changeTab(tab) {
            // @change="$router.push('./users')"

            let route = '/organization/' + this.$route.params.orgId + '/' + tab
            this.$router.push(route)
        },
    },
}
</script>
